// Softwood runs a July–June fiscal year (the Pakistani standard).
//
//   Q1 = Jul – Sep      Q3 = Jan – Mar
//   Q2 = Oct – Dec      Q4 = Apr – Jun
//
// A report's `year` field stores the fiscal year it ENDS in, so the report for
// Apr–Jun 2026 is Q4 of FY 2025–26 and is stored as { year: 2026, quarter: "Q4" }.
// Q1/Q2 therefore fall in the previous calendar year (FY2026 Q1 = Jul–Sep 2025).

export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const QUARTER_MONTHS = {
  Q1: "Jul – Sep",
  Q2: "Oct – Dec",
  Q3: "Jan – Mar",
  Q4: "Apr – Jun",
};

// 2026 -> "FY 2025–26"
export const fyLabel = (fiscalYear) => {
  const y = Number(fiscalYear);
  if (!y) return "";
  return `FY ${y - 1}–${String(y).slice(2)}`;
};

// 2026 -> "2025–26" (compact, for tight spaces like cards)
export const fyShort = (fiscalYear) => {
  const y = Number(fiscalYear);
  if (!y) return "";
  return `${y - 1}–${String(y).slice(2)}`;
};

// The calendar year a fiscal quarter falls in (Q1/Q2 are in the prior year).
export const calendarYearFor = (quarter, fiscalYear) =>
  quarter === "Q1" || quarter === "Q2" ? Number(fiscalYear) - 1 : Number(fiscalYear);

// ("Q4", 2026) -> "Apr – Jun 2026"   ("Q1", 2026) -> "Jul – Sep 2025"
export const fiscalDateLabel = (quarter, fiscalYear) => {
  const months = QUARTER_MONTHS[quarter];
  if (!months || !fiscalYear) return "";
  return `${months} ${calendarYearFor(quarter, fiscalYear)}`;
};
